const PaperExchangeList = () => import('Views/paperExchange/paperExchange-list-new-ui');
const PaperExchangeEdit = () => import('Views/paperExchange/paperExchange-edit-new-ui');
const PaperExchangeDetail = () => import('Views/paperExchange/paperExchange-detail-new-ui');

export default[
  { path: '/paperExchange-list', component: PaperExchangeList },
  { path: '/paperExchange-list', component: PaperExchangeList },
  { path: '/paperExchange-edit/:id', component: PaperExchangeEdit },
  { path: '/paperExchange-detail/:id', component: PaperExchangeDetail },
];



// WEBPACK FOOTER //
// ./src/router/paperExchange.js